/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_itemSearch = {
    readonly filters: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_filters">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_itemSearch" | "SbSharedSkyscraperAd_itemSearch">;
    readonly " $refType": "SbRespRefineMenuSelector_itemSearch";
};
export type SbRespRefineMenuSelector_itemSearch$data = SbRespRefineMenuSelector_itemSearch;
export type SbRespRefineMenuSelector_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuSelector_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuSelector_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "filters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenu_filters",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSkyscraperAd_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'bcff1f9c493774ef98e38edc26eb899b';
export default node;
